import React, { useState, useCallback, useEffect } from 'react';
import { utils } from 'utils';
import { WelcomeStep } from './Welcome';
import { CustomResetPassword } from './CustomResetPassword';

export const REGISTRATION_STEPS = {
  WELCOME: 'welcome',
  CREATE_PASSWORD: 'createPassword',
};

const CustomRegistrationFlow = ({
  onCreatePassword,
  error,
  isSubmitting,
  onClearError,
  onWelcomeStepChange,
  onStepChange,
  oktaRequirements = [],
}) => {
  const [step, setStep] = useState(REGISTRATION_STEPS.WELCOME);
  const logEvent = utils.eventsLogger?.unifiedLoginDio?.track;

  useEffect(() => {
    onStepChange?.(step);
  }, [step, onStepChange]);

  useEffect(() => {
    onWelcomeStepChange?.(step === REGISTRATION_STEPS.WELCOME);
  }, [step, onWelcomeStepChange]);

  const handleWelcomeContinue = useCallback(() => {
    if (logEvent) {
      logEvent('registration_Choose_password', 'pageview');
    }
    onClearError?.();
    setStep(REGISTRATION_STEPS.CREATE_PASSWORD);
  }, [logEvent, onClearError]);

  switch (step) {
    case REGISTRATION_STEPS.WELCOME:
      return <WelcomeStep onContinue={handleWelcomeContinue} />;
    case REGISTRATION_STEPS.CREATE_PASSWORD:
      return (
        <CustomResetPassword
          onCreatePassword={onCreatePassword}
          error={error}
          isSubmitting={isSubmitting}
          oktaRequirements={oktaRequirements}
        />
      );
    default:
      return <WelcomeStep onContinue={handleWelcomeContinue} />;
  }
};

export default CustomRegistrationFlow;
